import React from "react";

function CatalogManagementSvg({ color = "#000000", width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 68 68"
      fill={color}
    >
      <g>
        <path
          d="M18.884 23.38V11.631h-8.526c-.904 0-1.636.732-1.636 1.626V47.92a3.316 3.316 0 0 0 3.435 3.313c1.799-.061 3.201-1.596 3.201-3.394V25.015c0-.904.732-1.636 1.636-1.636zM55.568 20.605c0-.904-.731-1.636-1.636-1.636h-1.28v4.41h2.916z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
        <path
          d="M56.392 25.412H18.539a1.14 1.14 0 0 0-1.149 1.148v21.36c0 .122-.01.244-.03.366-.04.508-.142.996-.305 1.453-.264.732.295 1.504 1.077 1.504h3.293v-1.037c0-1.554 1.168-2.916 2.713-3.14l.732-.111c.203-.6.447-1.2.741-1.779l-.447-.6c-.924-1.26-.792-3.038.315-4.135l1.453-1.453c.61-.6 1.403-.935 2.246-.935.691 0 1.342.223 1.89.63l.6.437c.58-.285 1.168-.529 1.778-.732l.112-.742a3.155 3.155 0 0 1 3.14-2.703h2.053a3.165 3.165 0 0 1 3.15 2.703l.112.742c.61.203 1.199.447 1.778.732l.6-.437c.548-.407 1.199-.63 1.88-.63.853 0 1.646.335 2.245.925l1.463 1.453a3.21 3.21 0 0 1 .305 4.156l-.447.59c.295.579.539 1.168.742 1.778l.722.111a3.18 3.18 0 0 1 2.713 3.14v1.037h3.638c.894 0 1.626-.732 1.626-1.636v-21.31a2.884 2.884 0 0 0-2.886-2.885zM50.624 4.248a1.75 1.75 0 0 0-1.75-1.748H22.668a1.75 1.75 0 0 0-1.75 1.748V23.38h29.706V4.248zm-13.912 14.91H24.96a1.016 1.016 0 1 1 0-2.032h11.752a1.016 1.016 0 1 1 0 2.032zm9.874-5.2H24.96a1.016 1.016 0 1 1 0-2.032h21.626a1.016 1.016 0 1 1 0 2.032zm0-5.2H24.96a1.016 1.016 0 1 1 0-2.032h21.626a1.016 1.016 0 1 1 0 2.032z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
        <path
          d="m51.006 49.078-2.033-.304a11.317 11.317 0 0 0-1.554-3.75l1.23-1.656a1.134 1.134 0 0 0-.113-1.494l-1.453-1.453a1.157 1.157 0 0 0-1.493-.112l-1.657 1.23a11.459 11.459 0 0 0-3.74-1.545l-.304-2.043a1.149 1.149 0 0 0-1.138-.975h-2.053c-.559 0-1.047.416-1.128.975l-.315 2.043a11.404 11.404 0 0 0-3.73 1.544l-.538-.396-1.128-.823a1.13 1.13 0 0 0-1.484.102l-1.463 1.453a1.145 1.145 0 0 0-.112 1.494l1.22 1.656a11.496 11.496 0 0 0-1.535 3.75l-2.042.304c-.57.082-.986.56-.986 1.128v2.063c0 .57.417 1.047.986 1.128l2.042.305a11.497 11.497 0 0 0 1.535 3.75l-1.22 1.656a1.146 1.146 0 0 0 .112 1.494l1.463 1.453a1.143 1.143 0 0 0 1.484.112l1.667-1.23a11.648 11.648 0 0 0 3.729 1.555l.315 2.032c.081.56.559.976 1.128.976h2.053c.569 0 1.057-.417 1.138-.976l.305-2.032a11.703 11.703 0 0 0 3.74-1.555l1.656 1.23a1.157 1.157 0 0 0 1.493-.112l1.453-1.453a1.134 1.134 0 0 0 .112-1.494l-1.23-1.656a11.205 11.205 0 0 0 1.555-3.75c.143-.02 1.21-.183 2.033-.305a1.13 1.13 0 0 0 .975-1.128v-2.063c0-.569-.416-1.046-.975-1.128zm-13.282 8.18c-3.323 0-6.026-2.692-6.026-6.015a6.026 6.026 0 0 1 6.026-6.026 6.02 6.02 0 0 1 6.026 6.026 6.017 6.017 0 0 1-6.026 6.016z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
      </g>
    </svg>
  );
}

export default CatalogManagementSvg;
